import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaTarefasAgendadas from '../../../../lib/json/consultas/TarefasAgendadas.json'
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import { ConsultaAPI, ConsultaAPI_URL } from "../../../../backend/ConsultaAPI";
import { useNavigate } from "react-router-dom";
import { ErroMsg, SucessoMsg, formatDateColumn, formatarData } from "../../../contents/VariaveisGlobais";
import { usePopUp } from "../../../components/BootBox";
import { ConsumoAPI_DELETE } from "../../../../backend/ConsumoAPI";
import { NormalFont } from "../../../components/GridCell/styles";

function handleStatusTarefasAgendadas(item) {
    let status = item.value;

    switch (status) {
        case 'S':
          status = 'Habilitado';
          break;
        case 'N':
          status = 'Desabilitado';
          break;
        case 'E':
          status = 'Executado';
          break;
        default:
          status = 'Indefinido';
          break;
    }

    return status
}

function handleDataTarefasAgendadas(item) {
    const DataEvento = item.value
    const linha = item.row.original

    // Converter o valor de i para retornar o nome do mês
    const monthNames = [
        "Janeiro", "Fevereiro", "Março",
        "Abril", "Maio", "Junho", "Julho",
        "Agosto", "Setembro", "Outubro",
        "Novembro", "Dezembro"
    ];
    const dayOfWeekNames = [
        "Domingo", "Segunda-feira", "Terça-feira",
        "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"
    ];

    if (linha.Recorrente === 'S'){
        const dia = ( linha.Dia === '*' ? 'Todos os Dias' : 'Dia: ' + linha.Dia )
        const mes = ( linha.Mes === '*' ? 'Todos os Meses' : 'Mês: ' + monthNames[linha.Mes -1] )
        const diaSemana = ( linha.DiaSemana === '*' ? 'Todos os Dias' : 'Todo(a): ' + dayOfWeekNames[linha.DiaSemana] )

        const returnTexto = (linha.Dia === '*' && linha.DiaSemana === '*' ? dia + '|' + mes : dia + '|' + mes + '|' + diaSemana );

        return returnTexto
    }else{
        return formatDateColumn(item)
    }
}

function handleNumeroTarefaAgendada(item, DisparaBootBox, FechaBootBox, ){
    const { Descricao } = item.row.original 
    const IdTarefa = item.value;

    return ( <>
                {<NormalFont tooltipText={"Ultimas Execuções"} onClick={(e)=> ExecucoesScheduler(IdTarefa, Descricao, DisparaBootBox, FechaBootBox)}>{IdTarefa}</NormalFont>}                
            </> )
}

const ExecucoesScheduler = async(IdTarefa, NomeTarefa, DisparaBootBox, FechaBootBox) => {
    let columnsExecucao = [
        { Header: 'Data Execução'   , accessor: 'DataExecucao', Cell: (e) => { return formatarData(e.value) } },
        { Header: 'Hora Execução'   , accessor: 'HoraExecucao', Cell: (e) => { return e.value.split('T')[1].split('.')[0]; } },
        { Header: 'Retorno'         , accessor: 'RetornoExecucao' },
        { Header: 'Execução Manual' , accessor: 'ExecucaoManual', Cell: (e) => { return e.value == 'S' ? 'SIM' : 'NÃO' } },
    ];

    const oRetorno = await ConsultaAPI_URL(`tarefasAgendadas/execucoes?TarefaAgendadaId=${IdTarefa}`)
    
    let aDataFilaAprovacao = oRetorno.data;

    const Mensagem = (
        <ResponsiveDataTable columns={columnsExecucao} data={aDataFilaAprovacao} buttons={[]} habilitaBuscar={false} />
    );

    DisparaBootBox('Ultimas Execuções Tarefa ' + IdTarefa + ' - ' + NomeTarefa, Mensagem, [{ variant: 'light', action: FechaBootBox, label: '↩ Voltar' }], {}, null, 'xl');
}

function ListaTarefasAgendadas(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        {
            Header: 'ID',
            accessor: 'Id',
            Cell: (item) => handleNumeroTarefaAgendada(item, DisparaBootBox, FechaBootBox)
        },
        {
            Header: 'Descrição',
            accessor: 'Descricao',
        },
        {
            Header: 'Data Agendamento',
            accessor: 'Data',
            Cell: handleDataTarefasAgendadas
        },
        {
            Header: 'Hora Agendamento',
            accessor: 'Horario',
        },
        {
            Header: 'Status',
            accessor: 'Habilitado',
            Cell: handleStatusTarefasAgendadas
        },
    ];
    
    var [carregar, setCarregar] = useState(false);
    var [data, setData]   = useState([]);
    
    useEffect(() => {
        loadListaTarefasAgendadas();
    }, []);

    // Processa consulta do grid
    const loadListaTarefasAgendadas = async() => {
        setCarregar(true);
        const consultaDefault  = ConsultaTarefasAgendadas.consulta;
        const retConsulta = await ConsultaAPI( consultaDefault );
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.Id}`)
    }
    
    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.Id}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.values.Id;
        const Mensagem = `Tem certeza que deseja excluir o registro ${idRow + ' - ' + row.values.Nome}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(id) => {
        FechaBootBox()
        try {
            setCarregar(true);
            const rota = 'tarefasAgendadas/' + id;
            const retConsumo = await ConsumoAPI_DELETE(rota);
            SucessoMsg(retConsumo.description);
            loadListaTarefasAgendadas();
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };

    const handleExecutarTarefa = async(row) => {
        const idRow = row.values.Id;

        setCarregar(true)
        try {
            const oRetorno = await ConsultaAPI_URL(`tarefasAgendadas/processTask?Id=${idRow}`)
            const erroRet = oRetorno?.error || "";

            if (erroRet){
                ErroMsg("Falha ao processar!" + erroRet);
            }else{
                SucessoMsg("Processado com Sucesso!")
            }
        }catch(error){
            ErroMsg("Falha ao processar!" + error)
        }        
        setCarregar(false)
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Agendador de Tarefas"/>
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadListaTarefasAgendadas}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"},
                            {isVisual: true, action: handleExecutarTarefa, label: "Executar", icone: "MdPlaylistPlay", style: "success"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaTarefasAgendadas;